import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";

export const EmptyState = ({ text }: { text: string }) => (
  <Box display="flex" justifyContent="center" alignItems="center" flexGrow={1} minHeight={0}>
    <Typography variant="body1" fontSize={14}>
      {text}
    </Typography>
  </Box>
);
